import { render, staticRenderFns } from "./ShowMenus.vue?vue&type=template&id=06b6f414&scoped=true"
import script from "./ShowMenus.vue?vue&type=script&lang=ts"
export * from "./ShowMenus.vue?vue&type=script&lang=ts"
import style0 from "./ShowMenus.vue?vue&type=style&index=0&id=06b6f414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6f414",
  null
  
)

export default component.exports